import {HttpAxiosRequest} from "../httpAxiosBase";
import {ClientNotification, MailUpdateDTO} from "../../types/client/clientData";

export const HttpOnboarding = {
    getEndpoint: (url = ''): string => `onboarding${url}`,
    
    updateClientMail: (mail: MailUpdateDTO) : Promise<number> => {
        return HttpAxiosRequest.post(
            HttpOnboarding.getEndpoint('/actualizar-mail-cliente'),
            {...mail}
        )
    },
    
    getNotifications : (clientId: number) : Promise<ClientNotification[]> => {
        return HttpAxiosRequest.get(
            HttpOnboarding.getEndpoint(`/${clientId}/notificaciones`)
        )
    },
    
    getNotificationsSummary : (clientId: number) : Promise<ClientNotification[]> => {
        return HttpAxiosRequest.get(
            HttpOnboarding.getEndpoint(`/${clientId}/notificaciones-resumen`)
        )
    },
}